import { FC, useState } from 'react';
import { Card, CardContent, Grid, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SCUIButton } from '../../../../atomic/atoms';
import { GlobaldataCommand } from '../../../../services/command';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { GDT } from '../globalDataTokenManagement.classes';

interface IProps {
    selectedRow?: any;
    onClose?: any;
    refresh?: any;
}
export const AddUpdateGlobalDataTokenDrawer: FC<IProps> = ({ selectedRow, onClose, refresh }) => {
    const { t } = useTranslation();
    const [tokenName, setTokenName] = useState<string>(selectedRow.tokenName);
    const handleAddGlobaldataToken = () => {
        if (!tokenName) {
            Swal.fire('Hata!', 'İlgili alanı doldurunuz.', 'error');
            return;
        }
        let params = { tokenName: tokenName };
        if (tokenName && tokenName.trim().length > 0) {
            GlobaldataCommand.AddGlobaldataToken(params)
                .then((res) => {
                    if (res) {
                        Swal.fire(t('general.success'), 'Eklendi', 'success');
                        onClose();
                        refresh();
                    }
                })
                .catch((error) => {
                    if (error?.data?.Key) {
                        Swal.fire('Hata!', `${error?.data?.Key}`, 'error');
                    } else {
                        Swal.fire('Hata!', 'Token eklenirken bir hata oluştu!', 'error');
                    }
                    onClose();
                });
        } else {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        }
    };
    const isEdit = selectedRow?.id > 0;
    return (
        <Card className={GDT.drawerCard} data-token-id={selectedRow?.id}>
            <CardContent className={GDT.drawerCardContent}>
                <Grid container style={{ margin: '1.5rem', gap: '1rem' }} className={GDT.drawerInner}>
                    <Grid
                        container
                        className={GDT.drawerHeaderRow}
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                        }}
                    >
                        <Grid
                            container
                            className={GDT.drawerTitleBox}
                            sx={{
                                marginBottom: '3rem',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 10,
                                lg: 10,
                            }}
                        >
                            <h2 className={GDT.drawerTitle}>{isEdit ? 'Token Düzenle' : 'Token Ekle'}</h2>
                        </Grid>
                        <Grid
                            className={GDT.drawerCloseBox}
                            sx={{ marginTop: '0.5rem' }}
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 2,
                                lg: 2,
                            }}
                        >
                            <CloseIcon
                                className={`cursorPointer ${GDT.btnDrawerClose}`}
                                style={{ fontSize: '3rem' }}
                                onClick={onClose}
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        className={GDT.drawerFieldRow}
                        size={{
                            xs: 12,
                        }}
                    >
                        <Grid
                            size={{
                                xs: 12,
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid
                                    className={GDT.drawerFieldToken}
                                    sx={{ marginRight: '7rem' }}
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                    }}
                                >
                                    <TextField
                                        className={GDT.inputDrawerToken}
                                        fullWidth
                                        label="Token"
                                        type="text"
                                        value={tokenName}
                                        defaultValue={selectedRow?.tokenName}
                                        multiline
                                        onChange={(e: any) => setTokenName(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Kaydet Butonu */}
                    <Grid
                        container
                        justifyContent="flex-end"
                        className={GDT.drawerActions}
                        style={{ marginTop: '1rem', marginRight: '7rem' }}
                    >
                        <SCUIButton
                            className={GDT.btnDrawerSave}
                            onClick={() => {
                                handleAddGlobaldataToken();
                            }}
                            type={'primary'}
                            sizeType={'fixed'}
                            size={'l'}
                            text={'Kaydet'}
                        ></SCUIButton>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
